// extracted by mini-css-extract-plugin
export var inner = "RichTextNewsletterSignupForm-module--inner--354de";
export var root = "RichTextNewsletterSignupForm-module--root--25aa6";